import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { EventQuestions } from "../-components/event-questions";

export const Route = createFileRoute("/_auth/org/$orgId/event/$eventId/questions/")({
  component: Page
});

function Page() {
  const { event } = useRouteContext({
    from: "/_auth/org/$orgId/event/$eventId/questions/"
  });

  return (
    <div className="py-4 md:py-6">
      <EventQuestions eventId={event.id} />
    </div>
  );
}
